import { render, staticRenderFns } from "./DelProductModal.vue?vue&type=template&id=9bfb47fe&"
import script from "./DelProductModal.vue?vue&type=script&lang=js&"
export * from "./DelProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports